<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../../assets/pageloader.svg" class="pageloader" alt="pageloader">
    </div>
    <div class="col-12 pb-5 mb-4" v-if="!pageloader">
      <div class="row no-gutters">
        <div v-if="showSidemenu" class="mt-2 togglemenu">
          <togglemenu  class="mt-5"></togglemenu>
        </div>
        <div class="col-md-12 col-lg-12 middle-background main-card">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="col-12 mt-5 pt-5" v-if="joberrorcode && (joberrorcode=='1021' || joberrorcode=='1050')">
            <no-selected-job :joberrorcode="joberrorcode"></no-selected-job>
          </div>
          <div v-else>
          <div class="row no-gutters mt-5">
            <div class="col-12 pl-lg-5 pr-lg-5 pt-lg-3 pt-3">
                <div class="d-lg-flex mt-lg-2 ml-2 mr-2">
                    <div class="d-flex col-lg-3 my-auto">
                        <div class="d-flex backgroundcolorblack borderadius12 height30 p-1 pl-3 pr-3 ml-lg-3 ml-2 pointer menubtn" @click="openSideMenu">
                            <img src="../../assets/HamburgrMenuWhite.svg" height="16px" class="my-auto" alt="hamburger">
                            <span class="fontsize12 white ml-1 my-auto">MENU</span>
                        </div>
                        <div class="d-flex backgroundcolor2 borderadius12 p-1 height30 pl-3 pr-3 pointer ml-lg-3 mb-2" @click="NavToListofJobs">
                            <img src="../../assets/JobBack.svg" height="20px" alt="back">
                            <span class="fontsize12 stylebold black ml-1">Back</span>
                        </div>
                    </div>
                    <div class="d-flex card-header1 col-lg-6 pl-0 pr-0">
                        <div class="d-flex col-12 p-1">
                            <div class=" input-group search-input p-0 mr-2"  >
                                <div class="input-group-prepend " >
                                    <span class="input-group-text img-input-group" id="basic-text">
                                        <img :src="searchimg" class="imgborder searchedInput" alt="search"/> 
                                    </span>
                                </div>
                                <input
                                class="form-control input-border border-0"
                                type="text" 
                                placeholder="Designation"  id="searchedInput" autocomplete="off"
                                @keyup="checkForReset"
                                aria-label="Search"  v-model="jobText"    
                                />
                            </div>
                            <div class="input-group search-input p-0 mr-2" >
                                <div class="input-group-prepend " >
                                    <span class="input-group-text img-input-group" id="basic-text">
                                        <img :src="locationimg" class="imgborder searchedInput" alt="search"/> 
                                    </span>
                                </div>
                                <input
                                class="form-control input-border border-0"
                                type="text"
                                @keyup="checkForReset"
                                placeholder="Location"  id="searchedInput" autocomplete="off"
                                aria-label="Search"  v-model="locationSearchtext"    
                                />
                            </div>
                            <div class="d-flex justify-content-end ">
                                <div class="d-flex">
                                    <a class="btn backgroundcolorwhite button-create btn-color borderradius20 mouseoverbtn2"  id="search" @click="getFilterResults">
                                      <span class="proximanova-semibold fontsize16 black60">Search</span>
                                    </a>
                                    <a class="btn backgroundcolorwhite ml-1 button-create btn-color borderradius20 mouseoverbtn2" v-if="jobText || locationSearchtext" id="search" @click="resetFilterData">
                                      <span class="proximanova-semibold fontsize16 black60">Reset</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <div class="row no-gutters mt-3" v-if="!noUserResumesPresent">
            <div class="col-lg-12 pl-lg-5 pr-lg-5 col-12 d-flex">
              <div class="col-lg-4 col-md-12">
                <user-resumes-list></user-resumes-list>
              </div>
              <div class="col-8 pl-0 d-none d-lg-block">
                <user-resume-details></user-resume-details>
              </div>
            </div>
          </div>
          <div class="row no-gutters" v-else>
            <div class="col-lg-12 pl-lg-5 pr-lg-5 col-12 d-flex">
              <div class="col-12 pl-0 pr-0 mt-3">
                <no-jobs-available></no-jobs-available>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Popover from "vue-js-popover";
import httpjob from "@/js/http-postjob.js"
import router from '../../router.js'
import UserResumesList from './UserResumesList.vue'
import UserResumeDetails from './UserResumeData.vue'
import togglemenu from '../../components/ToggleMenu.vue'
import noJobsAvailable from '../../components/NoJobsAvailable.vue'
import { bus } from "@/main.js";
import sessionUtils from "@/js/session-util.js";
import NoSelectedJob from "../../components/NoSelectedJob.vue"
Vue.use(Popover);
export default{
    components:{
      UserResumesList,
      noJobsAvailable,
      NoSelectedJob,
      UserResumeDetails,
      togglemenu
    },
    data(){
        return{
            pageloader: false,
            businessAccountId : null,
            joberrorcode : null,
            jobDetails : {},
            showSidemenu : false,
            searchimg: require('../../assets/Designation.svg'),
            locationimg: require('../../assets/Location.svg'),
            jobText : "",
            locationSearchtext : "",
            applyFilters : false,
            noUserResumesPresent : false
        }
    },
    created (){
        bus.$on('closeSideMenuJobDet', (data) => {
          this.showSidemenu = false
        }) 
        bus.$on("whenJobDontHaveApplicants", data => {
          console.log("getting data", data)
          if(data){
            this.noUserResumesPresent = true;
          }
        })
    },
    methods:{
      //this will invoke after click on back or list of jobs
        NavToListofJobs() {
            this.$router.go(-1)
        },
        openSideMenu() {
          if(screen.width < 900) {
            bus.$emit('openToggleMenu', 'togglemenumedium')
          }else{
            this.showSidemenu = true;
            bus.$emit('openToggleMenu', 'togglemenularge')
          }
        },
        getFilterResults(){
          this.applyFilters = true;
          this.getData()
        },
        getData(){
          let obj = {
            jobText : this.jobText,
            locationSearchtext : this.locationSearchtext
          }
          console.log("filterdata : ", obj)
          bus.$emit("getFilterIndividualResumes", obj)
        },
        resetFilterData() {
          this.jobText = '';
          this.locationSearchtext = '';
          this.noUserResumesPresent = false;
          this.getData()
        },
        checkForReset() {
          console.log("check")
          if(this.jobText.length===0 && this.applyFilters && this.locationSearchtext.length===0){
            console.log("into reset")
            this.resetFilterData()
          }
        }
    },
    mounted() {
      window.scrollTo(0, 0)
      this.businessAccountId = sessionUtils.getBusinessAccountId()
      bus.$on("refreshFindResumesList", data => {
        if(data){
          this.resetFilterData()
        }
      })
      // this.getJobDetails()
    },
    beforeDestroy(){
        bus.$off('openToggleMenu')
        bus.$off('getUserResumesByStatus')
        bus.$off('whenJobDontHaveApplicants')
        bus.$off('refreshFindResumesList')
    },
}
</script>
<style scoped>
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.dropdown-position-bottom.postvideomenu {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 170px !important;
    left: unset !important;
  }
  .vue-popover.dropdown-position-bottom.postvideomenu:before {
    display: none !important;
  }
  .dropdown-position-bottom.postvideomenu1{
    right: 0;
  }
  .actionlink:hover{
    background: #dddfe5 !important;
    border-radius: 10px !important;
    cursor: pointer;
  }
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.selectedBackground{
  background-color: rgba(161, 166, 179,.2) !important;
}
.dot{
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background-color: tomato;
}
select > option{
  background-color: white;
  color: black;
}
.img-fluid{
  max-width: none;
}
.mouseoverjobsection{
    border-radius: 10px;
}
.mobileview{
  overflow: auto;
}
.togglemenu{
  margin-top: 8px !important;
}
.backgroundcolor6{
  height: 25px;
}
.btntext{
  display: none;
}
.card-header1 {
  border: 1px solid #d9dce1;
  background-color: rgba(161, 166, 179,0.06);
 
  border-radius: 8px;
} 
.input-group-prepend{
  margin-right: 0 !important;
  /* background-color: rgba(161, 166, 179,0.1); */
  /* padding: 1px 0px 1px 10px; */
  border-radius: 10px 0 0 10px;
}
.imgborder {
	padding: 11px 15px 10px 20px;
	/* background-color: rgb(161, 166, 179,0.1); */
    background-color: white;
	border-radius: 10px 0px 0px 10px;
  }
  .imgborder-search {
	padding: 11px 15px 11px 10px;
	background-color: rgba(161, 166, 179,0.1);
	border-radius: 0px 10px 10px 0px;
  }
  .input-group-text {
  padding: 0px 0px 0px 0px !important;
}
.form-control {
  background-color: rgb(161, 166, 179,0.1) !important;
  border: 0px solid #ced4da !important;
  /* border-radius: 0px 10px 10px 0px !important; */
}
.form-control:focus{
    outline: none !important;
    box-shadow: none !important;   
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.1);
    border: #DDDFE5;   
}
.input-border{
  border-radius: 0px 10px 10px 0px !important;
}
.input-border:focus{
    outline: none !important;
}
#searchedInput{
    background-color: white !important;
}
@media only screen and (max-width: 600px) {
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
  .mouseoverjobsection{
    width: 150px !important;
    margin-right: 10px;
    border-radius: 10px;
  }
  .jobbtn{
    height: 25px;
  }
  .companyLogo{
    width: 45px !important;
  }
  .jobTitle{
    font-size: 18px;
  }
}
@media (max-width : 400px){
  .jobbtn{
    height: 20px;
    width: 20px;
  }
}
@media only screen and (min-width: 800px) {
  .btntext{
    display: block;
  }
}
@media (max-width: 1000px){
  .menubtn{
    display: none !important;
  }
}
@media screen and (max-width: 1050px) and (min-width : 1020px) {
  .mouseoverjobsection{
    width: auto;
  }
  .jobbtn{
    height: 35px;
  }
  .jobmainHead{
    display: flex !important;
    flex-direction: column !important;
  }
  .jobmainSub{
    margin-left: 0 !important;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
  .mouseoverjobsection{
    width: 200px;
    border-radius: 10px;
  }
  .jobbtn{
    height: 25px;
  }
}
@media screen and (min-width : 1400px) {
  .mouseoverjobsection{
    width: 11%;
}
}
</style>
